<template>
  <span :class="timeWrapperClasses">
    <span class="pthvSchedule-time">
      <span :class="{ 'time-past': (timeData.minutes < 0), 'time-canceled': timeData.isCanceled }">
        {{ $t(timeData.hourDisplayByStateCode(alwaysShowHours)) }}
      </span>

      <span class="pthvSchedule-indicators">
        <span v-if="timeData.reliability == 'T' && (indicators.any || indicators.scheduledService)" class="tooltip" :title="$t('scheduledService')" >
          <i class="icon-infos approx"></i>
        </span>

        <span v-if="timeData.isRealTime() && (indicators.any || indicators.realTime)" class="tooltip" :title="$t('realTime')">
          <i class="icon-infos realTime"></i>
        </span>

        <span v-if="timeData.isPerturbation() && (indicators.any || indicators.disturbed)" class="tooltip" :title="$t('disturbed')" >
          <i class="icon-infos rouge"></i>
        </span>

        <span v-if="timeData.reliability == 'V' && (indicators.any || indicators.diverted)" class="tooltip" :title="$t('diverted')" >
          <i class="icon-infos derivation"></i>
        </span>

        <span v-if="timeData.reliability == 'H' && (indicators.any || indicators.handicap)" class="tooltip" :title="$t('handicap')" >
          <i class="icon-infos handy"></i>
        </span>

        <span v-if="timeData.isDeparture && showDeparture && (indicators.any || indicators.departure)" class="tooltip" :title="$t('departure')">
          <i class="icon-infos departure"></i>
        </span>

        <span v-if="timeData.isTerminus && showTerminus && (indicators.any || indicators.terminus)" class="tooltip" :title="$t('terminus')">
          <i class="icon-infos terminus"></i>
        </span>
      </span>
    </span>
    <span v-if="showOccupancy && timeData.occupancy" class="occupancy-wrapper">
      <span :class="'occupancy occupancy-' + timeData.occupancy" :title="$t(timeData.occupancy)">
        {{ timeData.occupancy }}%
      </span>
    </span>
  </span>
</template>

<script>
export default {
  name: "ApthScheduleTime",
  props: {
    timeData: {
      type: Object,
      required: true
    },
    showOccupancy: {
      type: Boolean,
      required: false,
      default: true,
    },
    showDeparture: {
      type: Boolean,
      required: false,
      default: true,
    },
    showTerminus: {
      type: Boolean,
      required: false,
      default: true,
    },
    alwaysShowHours: {
      type: Boolean,
      required: false,
      default: false,
    },
    indicators: {
      type: Object,
      required: false,
      default: () => {
        return {
          'any': true,
        };
      },
    },
  },
  computed: {
    timeWrapperClasses() {
      let timeWrapperClasses = 'pthvSchedule-time-wrapper';
      timeWrapperClasses += (this.timeData.minutes < 0) ? ' time-past-wrapper' : '';
      timeWrapperClasses += (this.timeData.isCanceled) ? ' time-canceled-wrapper' : '';
      return timeWrapperClasses;
    },
  },
  methods: {}
};
</script>

<style lang="scss">
@import "../styles/utilities/_variables.scss";

$assetsPath : "../assets/appicons/";

.time-canceled-wrapper,
.time-canceled {
  color: red;
}
.time-canceled {
  text-decoration: line-through;
}
.time-canceled:after {
  content: "Suppr.";
  display:inline-block;
  text-decoration: none;
}
.time-past-wrapper,
.time-past {
  color: gray;
}
.time-past {
  font-style: italic;
}

.pthvSchedule-time {
  display: flex;
  align-items: center;
  justify-content: end;
  padding: 0.25rem;
  /*&:not(:last-child) {
    margin-right: 0.5rem;
    padding-right: 0.25rem;
    border-right: 1px solid rgba($apth_color-black, 0.15);
  }*/
}
.pthvSchedule-indicators {
  height: 1rem;
  display: flex;
  align-items: center;
  line-height: 1;
  span {
    display: inline-block;
  }
  .icon-infos {
    width: 2rem;
    height: 2rem;
    display: inline-block;
    line-height: 1rem;
    vertical-align: middle;
  }
  .icon-infos.flag {
    background: url(#{$assetsPath}info-flag.svg) no-repeat center center transparent;
    &:hover,
    &:focus {
      background: url(#{$assetsPath}info-flag-hover.svg) no-repeat center center
        transparent;
    }
  }
  .icon-infos.departure {
    background: url(#{$assetsPath}info-departure.svg) no-repeat center center transparent;
    &:hover,
    &:focus {
      //background: url(#{$assetsPath}/info-departure-hover.svg) no-repeat center center transparent;
    }
  }
  .icon-infos.terminus {
    background: url(#{$assetsPath}info-terminus.svg) no-repeat center center transparent;
    &:hover,
    &:focus {
      //background: url(#{$assetsPath}his.assetspath + info-terminus-hover.svg") no-repeat center center transparent;
    }
  }
  .icon-infos.rouge {
    background: url(#{$assetsPath}info-rouge.svg) no-repeat center center transparent;
    &:hover,
    &:focus {
      background: url(#{$assetsPath}info-rouge-hover.svg) no-repeat center center
        transparent;
    }
  }
  .icon-infos.approx {
    background: url(#{$assetsPath}info-approx.svg) no-repeat center center transparent;
    &:hover,
    &:focus {
      background: url(#{$assetsPath}info-approx-hover.svg) no-repeat center center
        transparent;
    }
  }
  .icon-infos.realTime {
    background: url(#{$assetsPath}info-realtime2.svg) no-repeat center center transparent;
    &:hover,
    &:focus {
      background: url(#{$assetsPath}info-realtime.svg) no-repeat center center transparent;
    }
  }
  .icon-infos.bleu {
    background: url(#{$assetsPath}info-bleu.svg) no-repeat center center transparent;
    &:hover,
    &:focus {
      background: url(#{$assetsPath}info-bleu-hover.svg) no-repeat center center
        transparent;
    }
  }
  .icon-infos.handy {
    background: url(#{$assetsPath}info-handy.svg) no-repeat center center transparent;
    &:hover,
    &:focus {
      background: url(#{$assetsPath}info-handy-hover.svg) no-repeat center center
        transparent;
    }
  }
  .icon-infos.derivation {
    background: url(#{$assetsPath}info-derivation.svg) no-repeat center center transparent;
    &:hover,
    &:focus {
      background: url(#{$assetsPath}info-derivation-hover.svg) no-repeat center center
        transparent;
    }
  }
}
</style>
